export default __webpack_public_path__ + "static/media/image-study-admin-w@3x.daf4b4bc.png";